import React from 'react'
import _ from 'lodash'

import {Button, Icon, Input} from 'antd'
import {Link} from 'react-router'

import {AuthService} from 'api/auth'

export class Register extends React.Component {
   static get propTypes() {
      return {
         notify:    React.PropTypes.object,
         redirect:  React.PropTypes.string,
         router:    React.PropTypes.object.isRequired,
         loginLink: React.PropTypes.object
      }
   }

   constructor(p) {
      super(p)

      this.state = {
         email:            '',
         password:         '',
         confirm_password: '',
         loading:          false
      }

      this.updateEmail = this.updateEmail.bind(this)
      this.updatePw = this.updatePw.bind(this)
      this.updateConfirmPw = this.updateConfirmPw.bind(this)
      this.handleSubmit = this.handleSubmit.bind(this)
   }

   componentWillUnmount() {
      this.setState({password: '', confirm_password: ''})
   }

   updateEmail(ev) {
      let email = ev.target.value

      this.setState({email})
   }

   updatePw(ev) {
      let password = ev.target.value

      this.setState({password})
   }

   updateConfirmPw(ev) {
      let confirm_password = ev.target.value

      this.setState({confirm_password})
   }

   handleSubmit(ev) {
      ev.preventDefault()

      let {email, password, confirm_password} = this.state,
         {notify} = this.props

      notify.clear()
      if (!email) {
         notify.add(<span>A email is required</span>, 'warning')

         return
      }

      if (!password) {
         notify.add(<span>You must enter a password</span>, 'warning')

         return
      }

      if (!confirm_password) {
         notify.add(<span>You must confirm your password</span>, 'warning')
         this.forceUpdate()

         return
      }

      if (password !== confirm_password) {
         notify.add(<span>Password did not match</span>, 'warning')

         return
      }

      let promise = AuthService.register(email, password)
         .catch(err => {
            this.setState({loading: false})

            let msg = 'An unknown error occured'

            switch (_.get(err, 'req.status', -1)) {
               case 400:
                  notify.add(
                     <span>Failed to register: {_.get(err, 'data.error', 'unknown')}</span>,
                     'error',
                  )
                  break

               case 401:
                  notify.add(<span>Failed to register: User already exists</span>, 'error')
                  break

               default:
                  notify.add(
                     <span>Failed to register: {_.get(err, 'data.error', 'unknown')}</span>,
                     'error',
                  )
                  break
            }
         })
         .then(([resp, req]) => {
            if (201 === req.status) {
               AuthService.login(email, password)
                  .then(() => {
                     if (this.props.redirect) {
                        this.props.router.push(this.props.redirect)
                     }
                  })
                  .done(_x => this.setState({loading: true}))
            } else {
               this.setState({loading: false})
            }
         })

      this.setState({promise, loading: true})
   }

   render() {
      const {loading} = this.state,
         {loginLink} = this.props

      return (
         <form onSubmit={this.handleSubmit}>

            <div className="form-header">
               <h4>Sign Up</h4>
            </div>

            <div className="form-input">
               <label htmlFor="register-email">Email address</label>
               <Input
                  type="text"
                  prefix={<Icon type="user" />}
                  name="register-email"
                  id="register-email"
                  onChange={this.updateEmail}
                  placeholder="email@address.com"
               />
            </div>

            <div className="form-input">
               <label htmlFor="register-password">Password</label>

               <Input
                  type="password"
                  prefix={<Icon type="lock" />}
                  name="register-password"
                  onChange={this.updatePw}
                  id="register-password"
                  placeholder="********"
               />
            </div>

            <div className="form-input">
               <label htmlFor="register-confirm-password">Confirm Password</label>

               <Input
                  type="password"
                  prefix={<Icon type="lock" />}
                  name="register-confirm-password"
                  onChange={this.updateConfirmPw}
                  id="register-confirm-password"
                  placeholder="********"
               />
            </div>

            <div className="text-right form-actions">
               {loginLink
                  ? <span className="link login">
                       <Link to={loginLink}>Already have an account? Sign in!</Link>
                    </span>
                  : null}

               <Button
                  type="primary"
                  loading={loading}
                  htmltype="submit"
                  icon="user-add"
                  onSubmit={this.handleSubmit}
                  onClick={this.handleSubmit}
               >

                  Register
               </Button>
            </div>
         </form>
      )
   }
}



// WEBPACK FOOTER //
// lib/bundle/auth/Register.jsx